import { makeStyles } from '@material-ui/core'

export const modalStyles = makeStyles(() => ({
  root: {
    height: '25rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem'
  },
  inputRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  },
  buttonRow: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center'
  },
  buttonRowInput: {
    margin: '1rem 0'
  },
  fullRow: {
    flex: 1
  },
  formLabel: {
    width: '100%'
  },
  errorMessage: {
    color: 'var(--color-danger-500)',
    fontStyle: 'italic',
    margin: '12px 0'
  },
  disabledCheckedSwitch: {
    '& .MuiSwitch-switchBase.Mui-checked.Mui-disabled + .MuiSwitch-track': {
      backgroundColor: 'var(--color-neutral-400)',
      opacity: 0.5
    },
    '& .MuiSwitch-switchBase.Mui-checked.Mui-disabled': {
      color: 'var(--color-neutral-300)'
    }
  }
}))
